<template>
  <div>
    <router-view v-show="$route.matched.length === 3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length === 2">
      <div class="main-page-content">
        <el-row class="table-search">
          <el-form :inline="true" :model="searchCondition" class="demo-form-inline">
            <el-form-item label="培训名称">
              <el-input
                v-model="searchCondition.name"
                placeholder="请输入培训名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
              <el-button type="primary" @click="goCreate">新建</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <ApeTable
          ref="apeTable"
          :data="trainingList"
          :columns="columns"
          :loading="loadingStaus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          highlight-current-row
        >
          <el-table-column
            slot="second-column"
            width="64"
            label="序号"
          >
            <template slot-scope="scope">
              <span>{{ offset + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="报名人数" width="100" align="center">
            <template slot-scope="scope">
              <span
                class="enrollment-link"
                @click="goEnrollment(scope.row)"
              >{{ scope.row.apply_count != null ? scope.row.apply_count : 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="goEdit(scope.row.id)">编辑</el-button>
              <span>/</span>
              <el-popover
                placement="top"
                width="150"
                v-model="scope.row.visible"
              >
                <p>确定要删除该培训吗？</p>
                <div style="text-align: right; margin: 0;">
                  <el-button type="text" size="mini" @click="scope.row.visible = false">取消</el-button>
                  <el-button type="danger" size="mini" @click="deleteTraining(scope.row)">确定</el-button>
                </div>
                <el-button slot="reference" type="text" size="mini" style="color: #f56c6c;">删除</el-button>
              </el-popover>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'

export default {
  components: {
    PageHeaderLayout,
    ApeTable
  },
  data() {
    return {
      searchCondition: {
        name: ''
      },
      loadingStaus: true,
      columns: [
        {
          title: '培训名称',
          value: 'name'
        },
        {
          title: '封面',
          type: 'image',
          value: 'cover_url',
          imgArr: 'cover_url_list',
          imgWidth: 50,
          imgHeight: 50,
          width: 200
        },
        {
          title: '状态',
          value: 'status_text',
          width: 120
        },
        {
          title: '更新时间',
          value: 'updated_at',
          width: 180
        }
      ],
      trainingList: [],
      pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      offset: 0
    }
  },
  watch: {
    "$route.matched": function(n) {
      if (n.length === 2) {
        this.initList();
      }
    },
  },
  methods: {
    searchButton() {
      this.initList('search')
    },
    goCreate() {
      this.$router.push({ path: '/training/create' })
    },
    goEdit(id) {
      this.$router.push({ path: `/training/${id}/edit` })
    },
    goEnrollment(row) {
      this.$router.push({ path: `/training/${row.id}/enrollment` })
    },
    switchPaging() {
      this.initList()
    },
    async initList(type) {
      this.loadingStaus = true
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      if (type === 'search') {
        pagingInfo.current_page = 1
      }
      const params = { ...this.searchCondition, ...pagingInfo }
      try {
        const res = await this.$api.getTrainingList(params)
        const list = res.list || res.data || []
        const pages = res.pages || { total: 0, offset: 0 }
        this.trainingList = list.map(item => {
          const coverUrlList = typeof item.cover_url === 'string'
            ? item.cover_url.split(',').map(url => url.trim()).filter(Boolean)
            : []

          return {
            ...item,
            cover_url_list: coverUrlList,
            status_text: item.status === 1 || item.status === '1' ? '开启' : '关闭',
            visible: false
          }
        })
        this.pagingData.total = pages.total || 0
        this.offset = pages.offset || 0
      } catch (e) {
        this.trainingList = []
        this.$message.error(e.message || '获取列表失败')
      }
      this.loadingStaus = false
    },
    async deleteTraining(row) {
      try {
        await this.$api.deleteTraining(row.id)
        row.visible = false
        this.$message.success('删除成功')
        this.initList('del')
      } catch (e) {
        this.$message.error(e.message || '删除失败')
      }
    }
  },
  mounted() {
    this.initList()
  }
}
</script>

<style lang="scss" scoped>
.table-search {
  margin-bottom: 16px;
}
.enrollment-link {
  color: #409eff;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
</style>
